<div [@slideInTop] class="navb"><app-navigation-bar></app-navigation-bar></div>

<section class="container-md pt-5 px-0">
  <div class="about-app-text" appInView (inView)="slideFromTop($event)">
    <h3>Приложението <b>MYLEV</b> е уеб базирано приложение за управление на лични финанси, създадено с цел дипломна
      работа.
      <br> Приложението е изработено от Станислав Валентинов Темелков,
      ВТУ "Св. Св. Кирил и Методий" от специалност "Софтуерно инженерство" и включва в изработката си технологии и
      умения
      придобити в процеса на обучение.
    </h3>
  </div>

  <div class="image-container" appInView (inView)="fadeIn($event)">
    <img src="../../assets/images/copy.png" alt="Copyright">
  </div>
</section>

<footer appInView (inView)="onInView($event)">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h3>За нас</h3>
        <p>Ние от MYLEV сме екип от професионалисти в областта на финансите, които вярват, че всеки заслужава да има
          контрол върху своите финанси. С нашата приложна програма може да проследите разходите си, да получите подробна
          информация за финансовото си състояние и да управлявате сметките си докато сте в движение.</p>
      </div>
      <div class="col-md-3">
        <h3>За връзка</h3>
        <ul>
          <li>Димитър Найденов 100</li>
          <li>Велико Търново, България</li>
          <li>Email: info@mylev.com</li>
        </ul>
      </div>
      <div class="col-md-3">
        <h3>Последвайте ни в</h3>
        <ul>
          <li><a href="#">Facebook</a></li>
          <li><a href="#">Twitter</a></li>
          <li><a href="#">Instagram</a></li>
          <li><a href="#">LinkedIn</a></li>
        </ul>
      </div>
    </div>
    <hr>
    <p>Изработено от <a href="http://temelkov.tk" target="_blank">Станислав Tемелков</a> &copy; MYLEV 2023</p>
  </div>
</footer>